export function normalizePositiveTimeStamp(value) {
  const normalized = Number(value);
  return Number.isFinite(normalized) && normalized > 0 ? normalized : null;
}

export function resolveChartLiveCandle({
  liveCandle,
  currentMarketEventTimeStamp,
  currentChartCandleTimeStamp,
  millisBetweenCandles,
  now = Date.now(),
}) {
  if (!liveCandle) {
    return null;
  }

  const liveCandleTimeStamp = normalizePositiveTimeStamp(liveCandle.timeStamp);
  if (liveCandleTimeStamp === null) {
    return null;
  }

  const referenceTimeStamp =
    normalizePositiveTimeStamp(currentMarketEventTimeStamp) ?? now;
  const chartCandleTimeStamp = normalizePositiveTimeStamp(
    currentChartCandleTimeStamp
  );
  const liveCandleIsStale =
    millisBetweenCandles &&
    referenceTimeStamp - liveCandleTimeStamp >= millisBetweenCandles;
  const liveCandleIsBehindChart =
    chartCandleTimeStamp !== null && liveCandleTimeStamp < chartCandleTimeStamp;

  return liveCandleIsStale || liveCandleIsBehindChart ? null : liveCandle;
}

export function shouldPreferMarketEventCandle({
  timeUnit,
  marketEventPrice,
}) {
  if (
    marketEventPrice === null ||
    marketEventPrice === undefined ||
    marketEventPrice === ''
  ) {
    return false;
  }
  return timeUnit === 'MINUTES' && Number.isFinite(Number(marketEventPrice));
}

export function resolveMarketEventTimeStampForChart({
  marketEventTimeStamp,
  nextCandleTimeStamp,
  now = Date.now(),
}) {
  const normalizedMarketEventTimeStamp =
    normalizePositiveTimeStamp(marketEventTimeStamp);
  const normalizedNextCandleTimeStamp =
    normalizePositiveTimeStamp(nextCandleTimeStamp);

  if (normalizedMarketEventTimeStamp === null) {
    // A wall-clock timestamp is not a market event. Using it here makes a
    // reload manufacture a new candle and assign the first quote as its open.
    // Wait for an exchange-timestamped event instead.
    return null;
  }

  if (
    normalizedNextCandleTimeStamp !== null &&
    normalizedMarketEventTimeStamp < normalizedNextCandleTimeStamp
  ) {
    return null;
  }

  return normalizedMarketEventTimeStamp;
}
